import { render, staticRenderFns } from "./qualityApprove.vue?vue&type=template&id=e39a84e8&scoped=true"
import script from "./qualityApprove.vue?vue&type=script&lang=js"
export * from "./qualityApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39a84e8",
  null
  
)

export default component.exports